import styled from 'styled-components';


const Container = styled.div`
  display: flex;
  height: 150px;
  width: 100%;
  padding-bottom: 7px;
  overflow-x: overlay;
`;

export const Styled = {
  Container,
};
